import { Grid } from "@mui/material";
import React from "react";
import { api } from "../../../../api/api";
import { useAuth } from "../../../../contexts/AuthProvider/AuthProvider";
import { formatDate } from "../../../../helpers";
import { StandadCard } from "../../../Cards";
import { Dialog } from "../../../Dialogs/Dialog";
import { StandardCellList } from "../../../Standards";
import { IPartnereDetails } from "./IPartnerDetails";

interface IVehicleList {
  vehicle_no: string;
  model_name: string;
  maker_name: string;
  status: "ACTIVE" | "PENDING";
  registration_year_v: number;
}

interface IPartnerDetails {
  partner_membership_details_id: number;
  partner_name: string;
  partner_id: number;
  customer_prospect_id: number;
  customer_name: string;
  certificate_number: string;
  certificate_start_date: string;
  certificate_end_date: string;
  address: string;
  chassis_no: string;
  maker: string;
  model: string;
  vehicle_type: string;
  membership_code: string;
  additional_details: {
    partner_plan: string;
    engine_number: string;
    registration_number: string;
  };
  status: string;
  create_dt: string;
  insert_dt: string;
}

export const PartnerDetails: React.FC<IPartnereDetails> = (props) => {
  const { open, connection, onClose } = props;

  console.log("clicked");

  console.log(connection.membership_code);

  const [vehicleList, setVehicleList] = React.useState<IVehicleList[]>([]);
  const [packageDetails, setPackageDetails] =
    React.useState<IPartnerDetails | null>(null);
  const [message, setMessage] = React.useState<string | null>(null);
  const auth = useAuth();

  const fetchPackageDetails = async () => {
    if (auth.user && auth.user.tokens) {
      try {
        const res = await api.get(
          `/check-partner-membership-details?membership_code=${connection.membership_code}`,
          {
            headers: {
              "auth-Token": auth.user.tokens.access,
            },
          }
        );
        if (res.data.data && res.data.data.length > 0) {
          setPackageDetails(res.data.data[0]);
          setMessage(null); // Reset message if data is found
        } else {
          setPackageDetails(null);
          setMessage(res.data.message || "No record found"); // Set message if no data is found
        }
      } catch (err: any) {
        console.error(err);
      }
    }
  };

  React.useEffect(() => {
    fetchPackageDetails();
  }, [connection]);

  return (
    <Dialog
      open={open}
      title="Customer Details"
      onClose={onClose}
      size="md"
      actions={[
        { type: "button", label: "Close", variant: "text", onClick: onClose },
      ]}
    >
      <Grid container spacing={1}>
        <Grid item xs={12} lg={12}>
          <StandadCard heading="Partner Details" sx={{ mb: 2 }}>
            {packageDetails ? (
              <StandardCellList
                colSize={3}
                list={[
                  {
                    heading: "Membership Code",
                    data: {
                      type: "text",
                      value: packageDetails.membership_code,
                    },
                  },
                  {
                    heading: "Partner Name",
                    data: { type: "text", value: packageDetails.partner_name },
                  },
                  {
                    heading: "Customer Name",
                    data: { type: "text", value: packageDetails.customer_name },
                  },
                  {
                    heading: "Certificate Number",
                    data: {
                      type: "text",
                      value: packageDetails.certificate_number,
                    },
                  },
                  {
                    heading: "Certificate Start Date",
                    data: {
                      type: "text",
                      value: formatDate(packageDetails.certificate_start_date),
                    },
                  },
                  {
                    heading: "Certificate End Date",
                    data: {
                      type: "text",
                      value: formatDate(packageDetails.certificate_end_date),
                    },
                  },
                  {
                    heading: "Address",
                    data: { type: "text", value: packageDetails.address },
                  },
                  {
                    heading: "Chassis Number",
                    data: { type: "text", value: packageDetails.chassis_no },
                  },
                  {
                    heading: "Maker",
                    data: { type: "text", value: packageDetails.maker },
                  },
                  {
                    heading: "Model",
                    data: { type: "text", value: packageDetails.model },
                  },
                  {
                    heading: "Vehicle Type",
                    data: { type: "text", value: packageDetails.vehicle_type },
                  },
                  {
                    heading: "Status",
                    data: { type: "text", value: packageDetails.status },
                  },
                  {
                    heading: "Partner Plan",
                    data: {
                      type: "text",
                      value: packageDetails.additional_details.partner_plan,
                    },
                  },
                  {
                    heading: "Engine Number",
                    data: {
                      type: "text",
                      value: packageDetails.additional_details.engine_number,
                    },
                  },
                  {
                    heading: "Registration Number",
                    data: {
                      type: "text",
                      value:
                        packageDetails.additional_details.registration_number,
                    },
                  },
                  {
                    heading: "Create Date",
                    data: {
                      type: "text",
                      value: formatDate(packageDetails.create_dt),
                    },
                  },
                  {
                    heading: "Insert Date",
                    data: {
                      type: "text",
                      value: formatDate(packageDetails.insert_dt),
                    },
                  },
                ]}
              />
            ) : message ? (
              <p>{message}</p>
            ) : (
              <p>Loading package details...</p>
            )}
          </StandadCard>
        </Grid>
      </Grid>
    </Dialog>
  );
};
